/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

/**
 * Declarative source of truth for routes that hide the persistent chat
 * input (the app-root BottomToolbar). Opt a route out by adding its path
 * here — the toolbar reads this instead of hard-coding a per-route branch.
 *
 * Exposed as an `ObservableValue<boolean>` so a `visible=` binding
 * re-evaluates on every navigation without a remount.
 */

import { data, type ObservableValue } from '@amazon/vinyl-observable'
import { onNavigate } from '@/router/router'

// Matched exact OR as a path prefix so nested sub-routes inherit the
// opt-out. New routes are a one-line addition.
const CHAT_INPUT_HIDDEN_ROUTES: readonly string[] = ['/taste-collection', '/onboarding']

function hidesChatInput(p: string): boolean {
    return CHAT_INPUT_HIDDEN_ROUTES.some((route) => p === route || p.startsWith(route + '/'))
}

const hidden$ = data(hidesChatInput(window.location.pathname || '/'))

// Module-level singleton — never unsubscribed, matches the shell lifetime.
onNavigate((event) => {
    hidden$.value = hidesChatInput(event.current)
})

export const chatInputHidden$: ObservableValue<boolean> = hidden$
